@if (formGroup) {
  @if (formGroup.get(formGroupOrControlName); as control) {
    <div [formGroup]="formGroup" class="metabi-control">
      <app-field-label [for]="formGroupOrControlName">
        {{ getLabel() }}
      </app-field-label>
      <div class="input-wrapper">
        <input
          [formControlName]="formGroupOrControlName"
          [type]="type"
          [placeholder]="placeholder || getLabel()"
          [attr.autocomplete]="autocomplete"
          [attr.data-lpignore]="autocomplete === 'off' ? 'true' : null"
          [attr.data-1p-ignore]="autocomplete === 'off' ? 'true' : null"
          (blur)="onBlurEmitter.emit($event)"
          [class.disabled]="disabled"
          />
        @if (enableUpload) {
          <app-upload
            [accept]="accept"
            [multiple]="multiple"
            [directory]="directory"
            (onCompleted)="onUploadCompleted($event)"
            title="Click or drag to upload"
            [small]="true"
          ></app-upload>
        }
        @if (enablePrevious) {
          <button
            nz-button
            class="previous-button"
            (click)="showPrevious.emit(); $event.preventDefault()"
            >
            <i nz-icon nzType="appstore-add"></i>
          </button>
        }
      </div>
      @if (control.errors && control.touched) {
        <app-field-error>
          {{ curateValidationHint(control) }}
        </app-field-error>
      }
    </div>
  }
}
